import React from 'react';
import { Form, Checkbox, Input, Collapse } from 'antd';
import { createUseStyles } from 'react-jss'

import Collection from '../../../common/Collection'
import IzmenitPromokodiVYacheikakh from '../IzmenitPromokodiVYacheikakh';
import NovieYacheikiVPromokodah from '../NovieYacheikiVPromokodah';
import { POST, errorCatch, deleteInArray, JSX, CollectionServer, updateInArray, updateArrayInArray, GET } from 'fennec-ui'
import InputWithSearchModal from '../../components/InputWithSearchModal';
import UserFilter from '../UserFilter';
import UserSelector from '../UserSelector';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useFilteredContext } from '../../components/Filtered';
import CopyYacheikiVPromokodah from '../CopyYacheikiVPromokodah';
import Tooltip from '../../components/Tooltip';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { Panel } = Collapse;

const useStyles = createUseStyles({
    tabs: {
        '& .ant-tabs-nav': {
            margin: "0 0 6px 0"
        },
        '& .ant-tabs-tab + .ant-tabs-tab': {
            margin: "0 0 0 20px"
        },
        '& .ant-tabs-nav .ant-tabs-tab': {
            padding: "5px 0",
            fontSize: "13px"
        }
    },
    collapse: {
        '& .ant-collapse-content > .ant-collapse-content-box': {
            padding: "0px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow': {
            top: "-2px",
            left: "9px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: "4px 10px",
            paddingLeft: "25px",
            fontWeight: "300"
        },
        '&.ant-collapse .filtered .filtered-header-wrapper .ant-card-body': {
            padding: "7px",
        }
    },
    fieldName: {
        fontWeight: "300"
    },
    fieldValue: {
        fontStyle: "italic",
        color: "black",
        fontWeight: "300"
    }
})

export default function IzmenitPromokodi(props) {
    const classes = useStyles()
    const { object, form, auth, sourceKey, queryFilterContext, soruceID } = props;

    const promokodi = useFilteredContext();
    
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object,
                    promouter: object?.promouter?.user
                }}
            >
                <div style={{ paddingBottom: "10px" }}>
                    {object?.promokod &&
                        <div style={{ display: "flex", gap: "5px" }}>
                            {/* {JSX(()=>{console.log(object)})} */}
                            <div>
                                <span style={{ fontWeight: "300" }}>Промокод: </span>
                            </div>
                            <div>
                                <div>
                                    <span>{object?.promokod}</span>
                                </div>
                                {object?.meropriyatie && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{object?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(object?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(object?.meropriyatie?.mestoProvedeniya) ? "(" + object?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}
                                </div>}
                                {object?.organizatorFederatsiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>Федерация</span>
                                </div>}
                                {object?.organizatorRegionalnoeOtdelenieID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{object?.organizatorRegionalnoeOtdelenie?.nazvanie}</span>
                                </div>}
                                {object?.organizatorShkolaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{object?.organizatorShkola?.nazvanieShkoliTantsev}</span>
                                </div>}
                                {object?.organizatorMeropriyatiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{object?.organizatorMeropriyatiya?.nazvanie}</span>
                                </div>}
                            </div>
                        </div>
                    }
                </div>
                <Form.Item label="Описание"
                    name="opisanie"
                    rules={[{ required: true, message: 'Пожалуйста, описание!' }]}
                >
                    <Input />
                </Form.Item>
                {(props?.object?.meropriyatieID>0) && <Form.Item
                    name="shablonniiPromokod"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Шаблонный промокод
                        <Tooltip title='Школы, организаторы, независимые преподаватели могут самостоятельно создавать промокоды по шаблону, который задается в шаблонном промокоде.' />
                    </Checkbox>
                </Form.Item>}
                <Form.Item
                    name="notActive"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Неактивный
                    </Checkbox>
                </Form.Item>
                <Form.Item
                    name={"promouter"}
                    label={"Промоутер"}
                    tooltip='Пользователь, который является владельцем этого промокода, получающий агентское вознаграждение по этому промокоду.'
                    rules={[{ required: false, message: 'Укажите промоутера!' }]}
                >
                    <InputWithSearchModal valueAsObject={true} auth={auth} title={"Поиск пользователя"} url={"/api/find/finduserfilter"} object={{}}
                        searchForm={UserFilter}
                        selectForm={UserSelector} />
                </Form.Item>
            </Form>
            <Collapse className={classes.collapse} >
                <Panel header="Позиции, на которые действует промокод" key="service">
                    <div style={{padding: "5px"}}>
                        <CollectionServer
                            auth={auth}
                            name={"KategoriiVoprosov"}
                            source={"/api/promokodivyacheikakh/bypromopage/" + object.ID}
                            // queryDetail={"collection"}

                            // filters={() => filtersFromMeta("KategoriiVoprosov")}

                            // mode="list"
                            // render={(item, idx) => (
                            //     <div style={{ padding: "0px 5px" }}>
                            //         <div>{getObjectDisplay(item, "KategoriiVoprosov", meta)}</div>
                            //         <div style={{ color: "#6a6a6a" }}></div>
                            //     </div>
                            // )}


                            // linksModelActions={"inline"}
                            // linksModelActions={true}
                            // linksCompareFunction={(obj)=>{
                            //     return _.get(obj, "relation.reference.object")
                            //     //return _.get(obj, "name")
                            // }}
                            // scheme={[
                            //     "VoprosiSudeiskikhAttestatsii.VariantiOtvetov",
                            //     "VoprosiSudeiskikhAttestatsii.ParametriVoprosa",
                            //     "ParametriShablonovTestov",
                            // ]}
                            // scheme={[
                            //     "VoprosiSudeiskikhAttestatsiiKategoriyaVoprosa.VariantiOtvetovVopros",
                            //     "VoprosiSudeiskikhAttestatsiiKategoriyaVoprosa.ParametriVoprosaVopros",
                            //     "ParametriShablonovTestovKategoriyaVoprosa"
                            // ]}

                            filters={() => [
                                {
                                    label: 'Название',
                                    display: item => item.yacheikaUslugi.nazvanie,
                                    name: "yacheikaUslugi.nazvanie",
                                    type: "string",
                                    filter: true,
                                    sort: true
                                },
                                {
                                    label: 'Процент',
                                    display: item => item.protsentObshcheiSummiUslugiNaMeropriyatii,
                                    name: "protsentObshcheiSummiUslugiNaMeropriyatii",
                                    type: "int",
                                    filterType: "range",
                                    func: ["min", "max"],
                                    filter: true,
                                    sort: true
                                },
                                {
                                    label: 'Сумма',
                                    display: item => item.rubleiOtObshcheiSummiUslugiNaMeropriyatii,
                                    name: "rubleiOtObshcheiSummiUslugiNaMeropriyatii",
                                    type: "int",
                                    filterType: "range",
                                    func: ["min", "max"],
                                    filter: true,
                                    sort: true
                                }
                            ]}
                            columns={() => [
                                {
                                    title: 'Название позиции',
                                    render: (text, record, index) => {
                                        return (record.yacheikaUslugi.nazvanie);
                                    }
                                },
                                {
                                    title: 'Скидка в процентах',
                                    render: (text, record, index) => {
                                        return (record.protsentObshcheiSummiUslugiNaMeropriyatii);
                                    }
                                },
                                {
                                    title: 'Скидка в рублях',
                                    render: (text, record, index) => {
                                        return (record.rubleiOtObshcheiSummiUslugiNaMeropriyatii);
                                    }
                                }
                            ]}
                            collectionActions={() => [
                                {
                                    action: {
                                        method: "POST",
                                        path: "/api/promokodivyacheikakh/new",
                                        mutation: "update",
                                        onValues: (values, context) => {
                                            return { ...values, promokodID: object.ID }
                                        },
                                        onClose: ({ unlock, close }, context) => close(),
                                    },
                                    title: "Добавить позицию",
                                    modal: {
                                        width: "40%",
                                        minWidth: "400px",
                                        title: "Выбор услуги",
                                    },
                                    form: NovieYacheikiVPromokodah,
                                    parentObject: object,
                                    soruceID: soruceID,
                                    sourceKey: sourceKey,
                                    queryFilterContext: queryFilterContext
                                },
                                {
                                    action: (values, unlock, close, { collection, setCollection, contextFilters }) => {
                                        if (values?.promokodID) {
                                            GET(auth, `/api/promokodivyacheikakh/copy/${values?.promokodID}/${object.ID}`, ({ data }) => {
                                                setCollection(o => updateArrayInArray(o, data));
                                                close()
                                            }, (err) => errorCatch(err, () => unlock()))
                                        } else {
                                            unlock()
                                        }
                                    },
                                    // action: {
                                    //     method: "POST",
                                    //     path: "/api/promokodivyacheikakh/new",
                                    //     mutation: "update",
                                    //     onValues: (values, context) => {
                                    //         return { ...values, promokodID: object.ID }
                                    //     },
                                    //     onClose: ({ unlock, close }, context) => close(),
                                    // },
                                    title: <i className="fa fa-clone" title="Копировать позиции из другого промокода"></i>,
                                    modal: {
                                        width: "40%",
                                        minWidth: "400px",
                                        title: "Копировать позиции из другого промокода",
                                    },
                                    form: CopyYacheikiVPromokodah,
                                    promokodi: promokodi,
                                    parentObject: object,
                                    soruceID: soruceID,
                                    sourceKey: sourceKey,
                                    queryFilterContext: queryFilterContext
                                }
                            ]}
                            modelActions={(item, index) => [
                                {
                                    title: "Изменить",
                                    modal: {
                                        width: "40%",
                                        minWidth: "400px",
                                        title: "Изменить услугу в промокоде",
                                    },
                                    action: {
                                        method: "POST",
                                        path: "/api/promokodivyacheikakh/update",
                                        mutation: "update",
                                        onValues: (values, context) => {
                                            return { ...values, ID: item.ID }
                                        },
                                        onClose: ({ unlock, close }, context) => close()
                                    },
                                    parentObject: object,
                                    form: IzmenitPromokodiVYacheikakh,
                                    sourceKey: sourceKey,
                                    queryFilterContext: queryFilterContext,
                                },
                                {
                                    title: "Удалить",
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, '/api/promokodivyacheikakh/delete', { ...item },
                                            () => setCollection(deleteInArray(collection, item)), errorCatch
                                        );
                                    },
                                }
                            ]}
                        />
                    </div>
                    {/* <Collection
                        auth={auth}
                        noPrint={true}
                        noPagination={false}
                        size="small"

                        source={"/api/promokodivyacheikakh/bypromo/" + object.ID}

                        filters={() => [
                            {
                                name: 'Процент',
                                value: item => item.protsentObshcheiSummiUslugiNaMeropriyatii,
                                field: "protsentObshcheiSummiUslugiNaMeropriyatii",
                                type: "string",
                                sort: true
                            },
                            {
                                name: 'Сумма',
                                value: item => item.rubleiOtObshcheiSummiUslugiNaMeropriyatii,
                                field: "rubleiOtObshcheiSummiUslugiNaMeropriyatii",
                                type: "string",
                                sort: true
                            }
                        ]}
                        columns={() => [
                            {
                                title: 'Название',
                                render: (text, record, index) => {
                                    return (record.yacheikaUslugi.nazvanie);
                                }
                            },
                            {
                                title: 'Процент',
                                render: (text, record, index) => {
                                    return (record.protsentObshcheiSummiUslugiNaMeropriyatii);
                                }
                            },
                            {
                                title: 'Сумма',
                                render: (text, record, index) => {
                                    return (record.rubleiOtObshcheiSummiUslugiNaMeropriyatii);
                                }
                            }
                        ]}
                        collectionActions={() => [
                            {
                                action: {
                                    method: "POST",
                                    path: "/api/promokodivyacheikakh/new",
                                    mutation: "update",
                                    onValues: (values, context) => {
                                        return { ...values, promokodID: object.ID }
                                    },
                                    onClose: ({ unlock, close }, context) => close(),
                                },
                                title: "Новая услуга",
                                modal: {
                                    width: "40%",
                                    minWidth: "400px",
                                    title: "Выбор услуги",
                                },
                                form: NovieYacheikiVPromokodah,
                                parentObject: object,
                                soruceID: soruceID,
                                sourceKey: sourceKey,
                                queryFilterContext: queryFilterContext
                            },
                            {
                                action: (values, unlock, close, { collection, setCollection, contextFilters }) => {
                                    if (values?.promokodID) {
                                        GET(auth, `/api/promokodivyacheikakh/copy/${values?.promokodID}/${object.ID}`, ({ data }) => {
                                            setCollection(o => updateArrayInArray(o, data));
                                            close()
                                        }, (err)=>errorCatch(err,()=>unlock()))
                                    } else {
                                        unlock()
                                    }
                                },
                                // action: {
                                //     method: "POST",
                                //     path: "/api/promokodivyacheikakh/new",
                                //     mutation: "update",
                                //     onValues: (values, context) => {
                                //         return { ...values, promokodID: object.ID }
                                //     },
                                //     onClose: ({ unlock, close }, context) => close(),
                                // },
                                title: <i className="fa fa-clone"></i>,
                                modal: {
                                    width: "40%",
                                    minWidth: "400px",
                                    title: "Копировать услуги для промокода",
                                },
                                form: CopyYacheikiVPromokodah,
                                promokodi: promokodi,
                                parentObject: object,
                                soruceID: soruceID,
                                sourceKey: sourceKey,
                                queryFilterContext: queryFilterContext
                            }
                        ]}
                        modelActions={(item, index) => [
                            {
                                title: "Изменить",
                                modal: {
                                    width: "40%",
                                    minWidth: "400px",
                                    title: "Изменить услугу в промокоде",
                                },
                                action: {
                                    method: "POST",
                                    path: "/api/promokodivyacheikakh/update",
                                    mutation: "update",
                                    onValues: (values, context) => {
                                        return { ...values, ID: item.ID }
                                    },
                                    onClose: ({ unlock, close }, context) => close()
                                },
                                parentObject: object,
                                form: IzmenitPromokodiVYacheikakh,
                                sourceKey: sourceKey,
                                queryFilterContext: queryFilterContext,
                            },
                            {
                                title: "Удалить",
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    POST(auth, '/api/promokodivyacheikakh/delete', { ...item },
                                        () => setCollection(deleteInArray(collection, item)), errorCatch
                                    );
                                },
                            }
                        ]}
                    />*/}
                </Panel>
            </Collapse>
        </>
    );
}
